module.exports = __webpack_public_path__ + "static/media/tw.d60f826a.svg";